import React, { useMemo } from 'react'
import { Html, Line } from '@react-three/drei'
import { const_var, params } from '../../../../../redux/reducers/reducer';

const OutLineSection = ({ leftWrapSize, rightWrapSize, overHangWidth, overHangLength, offSetRoofTrussH, offSetRoofTrussV }) => {
    
    const offsetCB = 0.2;
    const offsetHor = 0.15;
    const offsetVer = 0.2;

    const regularOffsetheight = useMemo(() => {
        let val = 0;
        if (params.p_r_s === 1) {
            val = const_var.roofRegularDst * 2;
        } else {
            val = 0
        }
        return val;
    }, [params.p_r_s])

    const topLinePoints = useMemo(() => (
        [
            [-(params.leanB_p_d / 2 + overHangWidth), params.leanB_p_h + params.leanB_p_w * params.b_l_t_r_pB / 12 + offsetVer + regularOffsetheight, -(params.p_d / 2 + offsetCB)],
            //right part
            [params.leanB_p_d / 2 + overHangWidth, params.leanB_p_h + params.leanB_p_w * params.b_l_t_r_pB / 12 + offsetVer + regularOffsetheight, -(params.p_d / 2 + offsetCB)],
            [params.leanB_p_d / 2 + rightWrapSize + overHangWidth, params.leanB_p_h  + offsetHor + regularOffsetheight, -(params.p_d / 2 + params.leanB_p_w + overHangLength)],
            [params.leanB_p_d / 2 + rightWrapSize + overHangWidth, params.leanB_p_h - offSetRoofTrussV, -(params.p_d / 2 + params.leanB_p_w + overHangLength)],
            [params.leanB_p_d / 2 + rightWrapSize + overHangWidth - (offSetRoofTrussH + 0.5), params.leanB_p_h - offSetRoofTrussV, -(params.p_d / 2 + params.leanB_p_w + overHangLength - offSetRoofTrussH)],
            [params.leanB_p_d / 2 + rightWrapSize + overHangWidth - (offSetRoofTrussH + 0.5), 0.2, -(params.p_d / 2 + params.leanB_p_w + overHangLength - offSetRoofTrussH)],
            //left part
            [-(params.leanB_p_d / 2 + leftWrapSize + overHangWidth - (offSetRoofTrussH + 0.5)), 0.2, -(params.p_d / 2 + params.leanB_p_w + overHangLength - offSetRoofTrussH)],
            [-(params.leanB_p_d / 2 + leftWrapSize + overHangWidth - (offSetRoofTrussH + 0.5)), params.leanB_p_h - offSetRoofTrussV, -(params.p_d / 2 + params.leanB_p_w + overHangLength - offSetRoofTrussH)],
            [-(params.leanB_p_d / 2 + leftWrapSize + overHangWidth), params.leanB_p_h - offSetRoofTrussV, -(params.p_d / 2 + params.leanB_p_w + overHangLength)],
            [-(params.leanB_p_d / 2 + leftWrapSize + overHangWidth), params.leanB_p_h  + offsetHor + regularOffsetheight, -(params.p_d / 2 + params.leanB_p_w + overHangLength)],
            [-(params.leanB_p_d / 2 + overHangWidth), params.leanB_p_h + params.leanB_p_w * params.b_l_t_r_pB / 12 + offsetVer + regularOffsetheight, -(params.p_d / 2 + offsetCB)],
        ]
    ), [params.leanB_p_d, params.p_d, params.leanB_p_w, params.leanB_p_h, params.b_l_t_r_pB, overHangWidth, overHangLength, offSetRoofTrussH, offSetRoofTrussV, rightWrapSize, leftWrapSize, regularOffsetheight])

    

    return (
        <>
            <Line
                points={topLinePoints}
                color="#00BE00"
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
             <Html occlude position={[0, params.leanB_p_h + params.leanB_p_w * params.b_l_t_r_pB / 12 + 0.5 , -params.p_d / 2 - 0.5]} style={{ pointerEvents: 'none' }}>
                <span style={{backgroundColor: 'white', border: 'solid 2px #00BE00', color: 'black', borderRadius: '50%', cursor: 'pointer', display:'flex', alignItems: 'center', justifyContent: 'center', padding: '3px', userSelect: 'none', fontSize: 'smaller'}}>
                    <i className='icon-drag-ico'/>
                </span>
            </Html>
        </>
    )
}

export default OutLineSection